<template>
  <div class="device-page">
    <div class="card hero-card">
      <div>
        <p class="eyebrow">DEVICE CENTER</p>
        <h2>设备管理</h2>
        <p class="muted">管理设备绑定、在线状态和后台解约。解约会保留历史签约/财务记录，并终止未结算收益。</p>
      </div>
      <div class="hero-stats">
        <div><strong>{{ rows.length }}</strong><span>设备总数</span></div>
        <div><strong>{{ boundCount }}</strong><span>已绑定</span></div>
        <div><strong>{{ onlineCount }}</strong><span>在线设备</span></div>
      </div>
    </div>

    <div class="device-tabs">
      <button :class="{active:activeSection==='inventory'}" @click="activeSection='inventory'"><b>机具编号库</b><span>录入、导入与查询机具</span></button>
      <button :class="{active:activeSection==='status'}" @click="activeSection='status'"><b>设备状态</b><span>在线状态与设备解约</span></button>
      <button :class="{active:activeSection==='logs'}" @click="activeSection='logs'"><b>解约记录</b><span>售后与审计追溯</span></button>
    </div>

    <div class="card inventory-card" v-if="activeSection==='inventory'">
      <div class="section-head"><div><h3>机具编号库</h3><p class="muted">先录入客户看到的机具编号，并关联 PCDN 平台 DeviceId/SN。H5 只能绑定这里存在且未绑定的编号。</p></div><button @click="showBatch=!showBatch" class="gray">{{showBatch?'收起批量导入':'批量导入'}}</button></div>
      <div class="inventory-form"><input v-model.trim="inventoryForm.machineCode" placeholder="机具编号（必填），例如 20260808"><input v-model.trim="inventoryForm.pcdnDeviceId" placeholder="设备SN（必填）"><input v-model.trim="inventoryForm.deviceName" placeholder="设备名称"><input v-model.trim="inventoryForm.remark" placeholder="备注"><button @click="saveInventory">添加机具</button></div>
      <div v-if="showBatch" class="batch-box"><textarea v-model="batchText" placeholder="每行一台：机具编号,PCDN DeviceId,设备名称,备注"></textarea><button @click="batchInventory">确认批量导入</button></div>
      <div class="inventory-tools"><div class="inventory-search"><span>搜索</span><input v-model.trim="inventoryKeyword" @input="inventoryPage=1" placeholder="输入机具编号、设备SN、设备名称、用户或备注"></div><select v-model.number="inventoryPageSize" @change="inventoryPage=1"><option :value="10">10条/页</option><option :value="20">20条/页</option><option :value="50">50条/页</option></select><span>共 {{filteredInventory.length}} 条</span></div>
      <div class="table-scroll" v-if="pagedInventory.length"><table><tr><th>机具编号</th><th>PCDN DeviceId/SN</th><th>设备名称</th><th>状态</th><th>绑定用户</th><th>备注</th><th>操作</th></tr><tr v-for="x in pagedInventory" :key="'i'+x.id"><td class="strong">{{x.machine_code}}</td><td>{{x.pcdn_device_id||'未关联'}}</td><td>{{x.device_name}}</td><td><span class="status-pill" :class="x.status==='BOUND'?'ok':'off'">{{x.status==='BOUND'?'已绑定':x.status==='AVAILABLE'?'可绑定':x.status}}</span></td><td>{{userLabel(x.bound_user_nickname,x.bound_user_id)}}</td><td>{{x.remark||'-'}}</td><td><button v-if="x.status!=='BOUND'" class="danger" @click="deleteInventory(x)">彻底删除</button></td></tr></table></div><div v-else class="empty-state"><div class="empty-icon">机</div><h3>{{inventory.length?'没有匹配的机具':'机具编号库为空'}}</h3><p>{{inventory.length?'请调整搜索关键词。':'请在上方录入单个机具，或使用批量导入。'}}</p></div>
      <div class="pagination" v-if="inventoryPageCount>1"><button class="gray" :disabled="inventoryPage<=1" @click="inventoryPage--">上一页</button><span>第 {{inventoryPage}} / {{inventoryPageCount}} 页</span><button class="gray" :disabled="inventoryPage>=inventoryPageCount" @click="inventoryPage++">下一页</button></div>
    </div>

    <div class="card" v-if="activeSection==='status'">
      <h3>设备接口模拟推送</h3>
      <div class="form-grid">
        <input v-model="form.sn" placeholder="SN">
        <input v-model="form.date" placeholder="日期 YYYY-MM-DD">
        <input v-model.number="form.trafficMb" placeholder="流量 MB">
        <select v-model="form.status"><option>ONLINE</option><option>OFFLINE</option></select>
        <button @click="push">推送状态</button>
      </div>
    </div>

    <div class="card" v-if="activeSection==='status'">
      <div class="section-head">
        <div>
          <h3>设备列表</h3>
          <p class="muted">状态每 60 秒自动向 PCDN 刷新。{{ statusRefreshText }}</p>
        </div>
        <button class="gray" @click="refreshStatuses(true)" :disabled="refreshingStatus">{{ refreshingStatus ? '刷新中…' : '刷新设备状态' }}</button>
      </div>
      <div class="inventory-tools device-search-tools"><div class="inventory-search"><span>搜索</span><input v-model.trim="deviceKeyword" @input="devicePage=1" placeholder="输入机具编号、设备SN、用户、状态或离线原因"></div><select v-model.number="devicePageSize" @change="devicePage=1"><option :value="10">10条/页</option><option :value="20">20条/页</option><option :value="50">50条/页</option></select><span>共 {{filteredDevices.length}} 条</span></div>
      <div class="table-scroll" v-if="pagedDevices.length"><table>
        <tr>
          <th>机具编号</th><th>设备SN</th><th>用户</th><th>客户姓名</th><th>签约手机号</th><th>签约地址</th><th>状态</th><th>离线/解约原因</th><th>绑定时间</th><th>解绑时间</th><th>操作</th>
        </tr>
        <tr v-for="x in pagedDevices" :key="x.id">
          <td class="strong">{{ x.machine_code || '-' }}</td>
          <td class="strong code-cell">{{ x.sn }}</td>
          <td>{{ userLabel(x.user_nickname,x.user_id) }}</td>
          <td>{{ x.customer_name || '-' }}</td>
          <td>{{ x.signed_phone || x.user_mobile || '-' }}</td>
          <td class="address-cell" :title="x.signed_address">{{ x.signed_address || '-' }}</td>
          <td><span class="status-pill" :class="x.status==='ONLINE'?'ok':'off'">{{ statusLabel(x.status) }}</span></td>
          <td>{{ x.offline_reason || '-' }}</td>
          <td>{{ x.bind_time || '-' }}</td>
          <td>{{ x.unbind_time || '-' }}</td>
          <td>
            <button v-if="x.user_id" @click="replaceDevice(x)">更换设备</button>
            <button v-if="x.user_id" class="danger" @click="terminate(x)">解约</button>
            <button class="danger" @click="purgeDevice(x)">彻底删除</button>
            <span v-if="!x.user_id" class="muted">未绑定</span>
          </td>
        </tr>
      </table></div><div v-else class="empty-state"><div class="empty-icon">设</div><h3>{{rows.length?'没有匹配的设备':'暂无已绑定设备'}}</h3><p>{{rows.length?'请调整搜索关键词。':'用户完成正式签约并支付成功后，设备会显示在这里。'}}</p></div>
      <div class="pagination" v-if="devicePageCount>1"><button class="gray" :disabled="devicePage<=1" @click="devicePage--">上一页</button><span>第 {{devicePage}} / {{devicePageCount}} 页</span><button class="gray" :disabled="devicePage>=devicePageCount" @click="devicePage++">下一页</button></div>
    </div>

    <div class="card" v-if="activeSection==='logs'">
      <div class="section-head">
        <div>
          <h3>解约记录</h3>
          <p class="muted">用于售后、财务和运营追溯。</p>
        </div>
        <button class="gray" @click="load">刷新</button>
      </div>
      <div class="table-scroll" v-if="logs.length"><table>
        <tr>
          <th>时间</th><th>SN</th><th>用户</th><th>解约原因</th><th>备注</th><th>操作人</th>
        </tr>
        <tr v-for="x in logs" :key="x.id">
          <td>{{ x.terminated_at }}</td>
          <td class="strong">{{ x.device_sn }}</td>
          <td>{{ userLabel(x.user_nickname,x.user_id) }}</td>
          <td>{{ x.reason }}</td>
          <td>{{ x.remark || '-' }}</td>
          <td>{{ x.operator }}</td>
        </tr>
      </table></div><div v-else class="empty-state"><div class="empty-icon">解</div><h3>暂无解约记录</h3><p>后台执行设备解约后会在这里保留审计记录。</p></div>
    </div>
  </div>
</template>

<script>
import { api, errorMessage } from '../api'

export default {
  data: () => ({
    activeSection:'inventory',inventoryKeyword:'',inventoryPage:1,inventoryPageSize:10,
    rows: [],deviceKeyword:'',devicePage:1,devicePageSize:10,
    refreshingStatus:false,statusRefreshText:'等待首次刷新',statusTimer:null,
    inventory: [],showBatch:false,batchText:'',inventoryForm:{machineCode:'',pcdnDeviceId:'',deviceName:'机具设备',remark:''},
    logs: [],
    form: {
      sn: 'SN-DEMO',
      date: new Date().toISOString().slice(0, 10),
      minutes: 1,
      trafficMb: 0,
      status: 'ONLINE'
    }
  }),
  computed: {
    filteredInventory () { const q=this.inventoryKeyword.toLowerCase();if(!q)return this.inventory;return this.inventory.filter(x=>[x.machine_code,x.pcdn_device_id,x.device_name,x.status,x.bound_user_nickname,x.remark].some(v=>String(v||'').toLowerCase().includes(q))) },
    inventoryPageCount () { return Math.max(1,Math.ceil(this.filteredInventory.length/this.inventoryPageSize)) },
    pagedInventory () { const page=Math.min(this.inventoryPage,this.inventoryPageCount);const start=(page-1)*this.inventoryPageSize;return this.filteredInventory.slice(start,start+this.inventoryPageSize) },
    filteredDevices () { const q=this.deviceKeyword.toLowerCase();if(!q)return this.rows;return this.rows.filter(x=>[x.machine_code,x.sn,x.user_nickname,x.user_id,x.customer_name,x.signed_phone,x.signed_address,this.statusLabel(x.status),x.status,x.offline_reason,x.bind_time,x.unbind_time].some(v=>String(v||'').toLowerCase().includes(q))) },
    devicePageCount () { return Math.max(1,Math.ceil(this.filteredDevices.length/this.devicePageSize)) },
    pagedDevices () { const page=Math.min(this.devicePage,this.devicePageCount);const start=(page-1)*this.devicePageSize;return this.filteredDevices.slice(start,start+this.devicePageSize) },
    boundCount () { return this.rows.filter(x => x.user_id).length },
    onlineCount () { return this.rows.filter(x => x.status === 'ONLINE').length }
  },
  created () { this.load();this.refreshStatuses(false);this.statusTimer=setInterval(()=>this.refreshStatuses(false),60000) },
  beforeDestroy () { if(this.statusTimer)clearInterval(this.statusTimer) },
  methods: {
    userLabel (nickname, id) { return nickname || (id ? `用户 #${id}` : '-') },
    statusLabel (status) { return status==='ONLINE'?'在线':status==='OFFLINE'?'离线':status==='BOUND'?'已绑定':status==='AVAILABLE'?'可绑定':status||'未知' },
    async refreshStatuses(showError){if(this.refreshingStatus)return;this.refreshingStatus=true;try{const r=await api.post('/admin/devices/refresh-status');const x=r.data.data||{};this.statusRefreshText=`最近刷新：${x.refreshedAt||'刚刚'}，在线 ${x.online||0} 台，离线 ${x.offline||0} 台${x.failed?`，失败 ${x.failed} 台`:''}`;await this.load()}catch(e){this.statusRefreshText='自动刷新失败';if(showError)alert(errorMessage(e))}finally{this.refreshingStatus=false}},
    async load () {
      try {
        const [devices, logs, inventory] = await Promise.all([
          api.get('/admin/devices'),
          api.get('/admin/terminations'),api.get('/admin/device-inventory')
        ])
        this.rows = devices.data.data || []
        this.logs = logs.data.data || []
        this.inventory=inventory.data.data||[]
      } catch (e) {
        alert(errorMessage(e))
      }
    },
    async saveInventory(){if(!this.inventoryForm.machineCode){alert('请输入机具编号');return}if(!this.inventoryForm.pcdnDeviceId){alert('请输入设备SN');return}try{await api.post('/admin/device-inventory',this.inventoryForm);this.inventoryForm={machineCode:'',pcdnDeviceId:'',deviceName:'机具设备',remark:''};await this.load()}catch(e){alert(errorMessage(e))}},
    async batchInventory(){try{const r=await api.post('/admin/device-inventory/batch',{text:this.batchText});alert('已导入 '+r.data.data+' 台机具');this.batchText='';await this.load()}catch(e){alert(errorMessage(e))}},
    async deleteInventory(x){if(!confirm(`确认彻底删除机具编号 ${x.machine_code}？\n\n会同时删除该编号关联的设备绑定记录，删除后这个编号可以重新分配给其他客户。`))return;try{await api.delete('/admin/device-inventory/'+x.id);await this.load()}catch(e){alert(errorMessage(e))}},
    async purgeDevice(x){
      const tip = x.user_id
        ? `确认彻底删除设备 ${x.sn}？\n\n· 删除设备绑定记录，编号可重新分配给其他客户\n· 终止未结算收益、取消待审核提现\n· 合同、协议、支付流水等证据全部保留`
        : `确认删除设备记录 ${x.sn}？删除后该编号可以重新分配。`
      if(!window.confirm(tip)) return
      try{await api.post('/admin/devices/purge',{sn:x.sn});alert('设备记录已删除，编号已释放');await this.load()}catch(e){alert(errorMessage(e))}
    },
    async push () {
      try {
        await api.post('/admin/device/push-online', this.form)
        await this.load()
      } catch (e) {
        alert(errorMessage(e))
      }
    },
    async replaceDevice (row) {
      if (!row.machine_code) { alert('当前设备缺少机器编号，请先检查设备库存关联'); return }
      const available = this.inventory.filter(x => x.status === 'AVAILABLE')
      const hint = available.length ? '\n可用机器编号：' + available.map(x => x.machine_code).join('、') : ''
      const newMachineCode = (window.prompt(`请输入用户 ${this.userLabel(row.user_nickname,row.user_id)} 要换绑的新机器编号${hint}`, '') || '').trim()
      if (!newMachineCode) return
      if (newMachineCode === row.machine_code) { alert('新机器编号不能与原机器编号相同'); return }
      if (!window.confirm(`确认更换设备？\n原机器编号：${row.machine_code}\n新机器编号：${newMachineCode}\n用户：${this.userLabel(row.user_nickname,row.user_id)}`)) return
      try {
        await api.post('/admin/devices/replace', { userId: row.user_id, originalMachineCode: row.machine_code, newMachineCode })
        alert('设备更换成功')
        await this.load()
      } catch (e) { alert(errorMessage(e)) }
    },
    async terminate (row) {
      const reason = window.prompt(`请输入设备 ${row.sn} 的解约原因`, '客户申请解约')
      if (!reason) return
      const remark = window.prompt('备注（可不填）', '') || ''
      if (!window.confirm(`确认解约设备 ${row.sn}？\n\n解约后会解绑设备、终止未结算收益，并取消待审核提现。`)) return
      try {
        await api.post('/admin/devices/terminate', {
          userId: row.user_id,
          sn: row.sn,
          reason,
          remark
        })
        alert('解约完成')
        await this.load()
      } catch (e) {
        alert(errorMessage(e))
      }
    }
  }
}
</script>

<style scoped>
.hero-card{display:flex;align-items:center;justify-content:space-between;gap:18px;background:linear-gradient(135deg,#ffffff,#f2fbf7 52%,#eef8f3)}
.eyebrow{margin:0 0 6px;color:#11965d;font-size:12px;font-weight:800;letter-spacing:1.6px}
.muted{color:#718079;margin:6px 0 0;line-height:1.7}
.hero-stats{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;min-width:360px}
.hero-stats div{padding:16px;border-radius:16px;background:rgba(255,255,255,.72);border:1px solid rgba(21,166,106,.12);box-shadow:0 12px 28px rgba(18,63,48,.08)}
.hero-stats strong{display:block;font-size:24px;color:#0f7f51}
.hero-stats span{display:block;margin-top:4px;color:#697a72;font-size:13px}
.form-grid{display:grid;grid-template-columns:1.3fr 1fr .8fr .8fr auto;gap:10px;align-items:center}
.inventory-form{display:grid;grid-template-columns:1fr 1.3fr 1fr 1.2fr auto;gap:10px;align-items:center}.batch-box{background:#f5faf7;border:1px dashed #b8d8c8;border-radius:14px;padding:12px;margin:12px 0}.batch-box textarea{height:120px}
.device-tabs{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px;margin:16px 0}.device-tabs button{display:grid;gap:4px;text-align:left;padding:15px 17px;border:1px solid #dce9e3;background:#fff;color:#315044;box-shadow:none}.device-tabs button b{font-size:16px}.device-tabs button span{font-size:12px;color:#778981}.device-tabs button.active{background:#0d8252;color:#fff;border-color:#0d8252;box-shadow:0 10px 22px rgba(13,130,82,.18)}.device-tabs button.active span{color:rgba(255,255,255,.78)}.inventory-tools{display:grid;grid-template-columns:minmax(320px,1fr) 130px auto;align-items:center;gap:12px;margin:14px 0 8px}.inventory-search{display:grid;grid-template-columns:auto minmax(0,1fr);align-items:center;gap:10px}.inventory-search>span{font-weight:800;color:#315044}.inventory-search input{width:100%;min-width:0}.inventory-tools>select{width:130px}.inventory-tools>span{white-space:nowrap;color:#718079;font-size:13px}
.pagination{display:flex;justify-content:flex-end;align-items:center;gap:10px;margin-top:14px}.pagination span{color:#60736b;font-size:13px}.pagination button:disabled{opacity:.45;cursor:not-allowed}
.section-head{display:flex;justify-content:space-between;gap:12px;align-items:flex-start;margin-bottom:10px}
.strong{font-weight:800;color:#14261f}
.status-pill{display:inline-flex;align-items:center;border-radius:999px;padding:5px 10px;font-size:12px;font-weight:800}
.status-pill.ok{background:#e9f8f1;color:#0f8b55}
.status-pill.off{background:#fff0f0;color:#d93025}
button.danger{background:linear-gradient(135deg,#ef5350,#c62828);box-shadow:0 8px 18px rgba(198,40,40,.18)}
@media (max-width:900px){
  .hero-card{display:block}
  .hero-stats{grid-template-columns:repeat(3,1fr);min-width:0;margin-top:14px}
  .form-grid{grid-template-columns:1fr 1fr}
  .inventory-form{grid-template-columns:1fr 1fr}
}
@media (max-width:520px){
  .device-tabs{grid-template-columns:1fr}.inventory-tools{grid-template-columns:1fr}.inventory-tools>select{width:100%}
  .hero-stats{grid-template-columns:1fr}
  .form-grid{grid-template-columns:1fr}
}
</style>
